import { render, staticRenderFns } from "./MentionsLegales.vue?vue&type=template&id=34770e1c&"
import script from "./MentionsLegales.js?vue&type=script&lang=js&"
export * from "./MentionsLegales.js?vue&type=script&lang=js&"
import style0 from "./MentionsLegales.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports